import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { UnitsDistributionBase } from '../base/units-distribution.base';

@Component({
    selector: 'ud-nba-point-margin',
    templateUrl: './default/nba/nba.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TranslocoModule, PipesModule]
})
export class NbaPointMarginComponent extends UnitsDistributionBase {
  // Used for NBA_POINT_MARGIN
  override getUnits(distribution: any): number {
    return super.getUnits(distribution);
  }
}